import "./mapPanel.scss";
import {
  Card, Row, Col, CloseButton
} from "react-bootstrap";
import { IDisposalSiteMapPanelProps } from "interfaces/components/Map/IDisposalSiteMapPanelProps";
import { useState, useEffect } from "react";
import { getDisposalSiteById } from "./DataMappers/MapDataMapper";

const DisposalSiteMapPanel = ({
  onClose,
  title,
  id,
  disposalSites
}: IDisposalSiteMapPanelProps) => {
  const [nextNonWorkingDay, setNextNonWorkingDay] = useState<
  string | undefined
  >();

  useEffect(() => {
    if (disposalSites) {
      const site = getDisposalSiteById(id.toString(), disposalSites);
      if (site) setNextNonWorkingDay(site.nextNonWorkingPeriodDisplayValue);
    }
  }, [disposalSites, id]);

  return (
    <div className="d-flex flex-column map-panel map-panel-border">
      <Card className="flex-grow-1">
        <Card.Header data-testid="disposalsite-card-header">
          Disposal Site Details
          <CloseButton aria-label="Close" variant="white" onClick={onClose} />
        </Card.Header>
        <Card.Body className="side-darawer">
          <Row>
            <Col>
              <strong>
                <span data-testid="site-name">Disposal Site Name</span>
              </strong>
            </Col>
          </Row>
          <Row className="mb-2">
            <Col>{title}</Col>
          </Row>

          {nextNonWorkingDay && (
            <>
              <Row>
                <Col>
                  <strong>
                    <span data-testid="next-nwd-title">
                      Next NWD (Non-working day)
                    </span>
                  </strong>
                </Col>
              </Row>
              <Row className="mb-2" data-testid="next-nwd-value">
                <Col>{nextNonWorkingDay}</Col>
              </Row>
            </>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default DisposalSiteMapPanel;
